export const STAFF_ROLES = [
  { value: "admin", label: "Admin" },
  { value: "partner", label: "Partner" },
  { value: "accounts", label: "Accounts" },
  { value: "staff", label: "Staff" },
];

export const EMPTY_STAFF = {
  uid: "",
  name: "",
  email: "",
  mobile: "",
  role: "staff",
  joiningDate: "",
  leavingDate: "",
  status: "active",
  communicationCentreEnabled: false,
};

export function normalizeStaff(data = {}) {
  const status = String(data.status || (data.isActive === false ? "inactive" : "active")).toLowerCase();
  return {
    uid: String(data.uid || data.id || "").trim(),
    name: String(data.name || data.username || "").trim(),
    email: String(data.email || "").trim().toLowerCase(),
    mobile: String(data.mobile || "").replace(/\s+/g, "").trim(),
    role: String(data.role || "staff").trim().toLowerCase(),
    joiningDate: String(data.joiningDate || "").trim(),
    leavingDate: String(data.leavingDate || "").trim(),
    status: status === "inactive" ? "inactive" : "active",
    communicationCentreEnabled: String(data.role || "staff").trim().toLowerCase() === "partner" && data.communicationCentreEnabled === true,
  };
}

export function validateStaff(staff, { isNew = false } = {}) {
  const errors = {};
  const value = normalizeStaff(staff);

  if (!value.name) errors.name = "Staff name is required.";
  if (!value.email) {
    errors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email)) {
    errors.email = "Enter a valid email address.";
  }

  if (value.mobile && !/^[6-9]\d{9}$/.test(value.mobile)) {
    errors.mobile = "Enter a valid 10-digit Indian mobile number.";
  }

  if (!STAFF_ROLES.some((role) => role.value === value.role)) {
    errors.role = "Select a valid role.";
  }

  if (value.joiningDate && value.leavingDate && value.leavingDate < value.joiningDate) {
    errors.leavingDate = "Leaving date cannot be before joining date.";
  }

  if (value.status === "inactive" && !value.leavingDate) {
    errors.leavingDate = "Leaving date is required for inactive staff.";
  }

  return errors;
}

export function staffDisplayName(staff = {}) {
  return staff.name || staff.username || staff.email || "Unnamed staff";
}
